export default __webpack_public_path__ + "static/media/empty_guidelines.83b41fdc.png";